import { Component, computed, input, output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { Workshop } from '../../../../api/workshop/workshop.model';
import { FrontendHeaderComponent } from '../../../_layout/frontend-header/frontend-header.component';
import { canRegisterForWorkshop } from '../../../../api/workshop/workshop.util';
import { i18nRouterLinkDirective } from '../../../../util/router/i18n-router-link.directive';

@Component({
  selector: 'app-workshop-header',
  standalone: true,
  imports: [
    RouterModule,
    MatTooltipModule,
    MatChipsModule,
    FrontendHeaderComponent,
    i18nRouterLinkDirective,
  ],
  templateUrl: './workshop-catalogue-header.component.html',
})
export class WorkshopCatalogueHeaderComponent {
  workshop = input<Workshop>();
  navigate = output<string>();
  protected readonly label = computed(() => this.workshop()?.theme.name || '');
  isWorkshopAvailable = computed(() => {
    const workshop = this.workshop();
    return workshop && canRegisterForWorkshop(workshop);
  });
  tooltipText = computed(() => {
    if (this.workshop()?.full) return $localize`Fully booked`;
    if (!this.isWorkshopAvailable()) return $localize`Registrations closed`;
    return '';
  });
}
